import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractTerminationReasonModule } from './contract-termination-reason/contract-termination-reason.module';
import { InsuranceReportingComponent } from './insurance-reporting/insurance-reporting.component';
import { SharedModule } from '../../shared/shared.module';
import { ProductCategoryModule } from './product-category/product-category.module';
import { ProductLineModule } from './product-line/product-line.module';
import { ProductModule } from './product/product.module';
import { InsuranceCompanyModule } from './insurance-company/insurance-company.module';
import { InsuranceRoutingModule } from './insurance-routing.module';
import { DocumentTypeModule } from './document-type/document-type.module';
import { ClaimTypeModule } from './claim-type/claim-type.module';
import { InsuranceClaimModule } from './insurance-claim/insurance-claim.module';

@NgModule({
  declarations: [InsuranceReportingComponent],
  imports: [
    CommonModule,
    ContractTerminationReasonModule,
    ProductCategoryModule,
    ProductLineModule,
    ProductModule,
    InsuranceCompanyModule,
    SharedModule,
    InsuranceRoutingModule,
    DocumentTypeModule,
    ClaimTypeModule,
    InsuranceClaimModule,
  ],
})
export class InsuranceModule {}
